<div style="flex: 1; display: flex; flex-direction: column; min-height: 0; padding: 0px 18px; height: 70vh; overflow: hidden;">
    <div class="action-bar" [class.scrolled-shadow]="isScrolled" [class.action-bar--pending]="updateAvailable || missingFields.length || !isDraftReady" [class.action-bar--missing]="missingFields.length">
        <div class="action-bar__hint">
            <mat-icon class="action-bar__hint-icon">{{ missingFields.length ? 'error_outline' : updateAvailable ? 'edit_note' : !isDraftReady ? 'hourglass_empty' : 'check_circle' }}</mat-icon>
            <span *ngIf="missingFields.length">{{ missingFields.length }} required {{ missingFields.length === 1 ? 'field is' : 'fields are' }} missing.</span>
            <span *ngIf="!missingFields.length">{{ updateAvailable ? 'You have unsaved changes. Update before sending.' : !isDraftReady ? 'Preparing draft...' : 'Draft is ready to send.' }}</span>
        </div>
        <button mat-flat-button class="send-btn" *ngIf="!updateAvailable && !missingFields.length" [disabled]="!isDraftReady" (click)="onSend()">
            <mat-icon>send</mat-icon>
            Send
        </button>
        <button mat-flat-button color="primary" *ngIf="updateAvailable || missingFields.length" [disabled]="isSavingChanges || !updateAvailable || hasClearedRequiredFields" (click)="saveChanges(dataModel)">
            <mat-spinner *ngIf="isSavingChanges" diameter="16" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isSavingChanges">sync</mat-icon>
            {{ isSavingChanges ? 'Updating...' : 'Update All' }}
        </button>
    </div>

    <div #scrollContainer 
        (scroll)="onScroll(scrollContainer)"
        style="overflow-y: auto; flex: 1; min-height: 0; padding: 0 2px 16px;">
        <!-- Kept mounted with [hidden] so the recipient list and its edits survive toggling -->
        <div class="recipients-view" [hidden]="!showRecipients">
            <div class="recipients-view__header">
                <span class="recipients-view__heading">
                    <span class="recipients-view__icon"><mat-icon>group</mat-icon></span>
                    <span class="recipients-view__text">
                        <span class="recipients-view__title">Recipients</span>
                        <span class="recipients-view__subtitle">Delivery channels &amp; signing order</span>
                    </span>
                </span>
                <mat-icon class="recipients-view__close" matTooltip="Close recipients" (click)="onCloseRecipients()">close</mat-icon>
            </div>
            <form [formGroup]="recipientForm">
                <formly-form
                    [form]="recipientForm"
                    [fields]="recipientFields"
                    [model]="dataModel"></formly-form>
            </form>
        </div>
        <form [formGroup]="formlyForm" [hidden]="showRecipients">
            <!-- Allow several open panels while required fields are missing, so each one stays revealed -->
            <mat-accordion [multi]="missingFields.length > 0">
                <formly-form 
                    [form]="formlyForm" 
                    [fields]="formlyFields" 
                    [model]="dataModel"></formly-form>
            </mat-accordion>
        </form>
    </div>
</div>